export default {
  welcome: "Hola Mundo"
}
